import { cn } from "@/lib/utils/cn";

import { issueIconClasses } from "./issue-icon-classes";

/**
 * An issue's icon, sized by the box its `className` gives it (`size-4`…) like
 * the lucide icons around it. Decorative unless told otherwise: the issue's name
 * always sits beside it.
 */
export function IssueIcon({
  icon,
  className,
  "aria-hidden": ariaHidden = true,
}: {
  icon?: string | null;
  className?: string;
  "aria-hidden"?: boolean;
}) {
  return (
    <span
      aria-hidden={ariaHidden}
      className={cn(
        "inline-flex items-center justify-center [container-type:size]",
        className,
      )}
    >
      <i
        className={cn(
          issueIconClasses(icon),
          "issue-icon-glyph text-[90cqmin] leading-none",
        )}
      />
    </span>
  );
}
